import axios from 'axios';

import routes from 'app/routes';

export default {
  update: (id, values, successCallback, errorCallback) => {
    axios
      .put(routes.api.affiliates.update(id), {
        affiliate: values,
      })
      .then((_resp) => {
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  goToPage: (url) => {
    document.location.href = url;
  },
};
